// extracted by mini-css-extract-plugin
export default {"navbarSpinner":"Spinner_navbarSpinner__nRMkL"};